import Vue from 'vue';
import VueRouter from  'vue-router';

// import Home from './components/Home';
// import SignIn from './components/SignIn';
// import SignUp from './components/SignUp';
import MyAccount from './components/User/MyAccount';
import Feed from './components/Listing/Feed.vue';
import Post from './components/Listing/Post.vue';
// import Cropping from './components/Listing/Cropping.vue';
import PhoneSignIn from './components/PhoneSignIn';
import PhoneSignUp from './components/PhoneSignUp';
import GMap from './components/GMap';
import firebase from 'firebase/app';
import 'firebase/auth';

Vue.use(VueRouter);

const routes = [
    // {
    //     path: '/',
    //     name: 'home',
    //     component: Home
    // },
    {
        path: '/signin',
        name: 'signin',
        component: PhoneSignIn
    },
    {
        path: '/signup',
        name: 'signup',
        component: PhoneSignUp
    },
    {
        path: '/myaccount',
        name: 'settings',
        component: MyAccount,
        beforeEnter: (to, from ,next) => {
            if (firebase.auth().currentUser) next()
            else next('/signin')
        }
    },
    {
        path: '/feed',
        component: Feed,
        name: 'feed',
        beforeEnter: (to, from ,next) => {
            if (firebase.auth().currentUser) next()
            else next('/signin')
        }
    },
    {
        path: '/post',
        component: Post,
        beforeEnter: (to, from ,next) => {
            if (firebase.auth().currentUser) next()
            else next('/signin')
        }
    },
    {
        path: '/',
        name: 'home',
        component: GMap,
    },
    // {
    //     path: '/cropper',
    //     component: Cropping,
    // },
]

export default new VueRouter({mode: 'history',routes})